import React from 'react';
import { Card } from 'semantic-ui-react';
import { datasetUrl } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import SystemFlag from '@/components/SystemFlag';
import DatasetStatusButtons from '../status/components/DatasetStatusButtons';
import { dataModelName, isVisibleDataModel } from '../datamodels/helper';

const DatasetCardItemWrapper = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  children,
  cohortAllowed,
  cohortSupported,
  cohortUnsupportedReasons,
  dataset,
  hasConditions,
  newCohort,
  newCohortCode,
  newRequestCode,
  onCheckBoxClick,
  showConditions,
  showStatus,
  single,
}) => (
  <CardItem className="aridhia-dataset-list-item">
    <NameDescriptionCard
      description={dataset.catalogue.description}
      entity="dataset"
      link={datasetUrl(dataset)}
      markdown
      name={dataset.catalogue.title}
      onSelect={onCheckBoxClick ? () => onCheckBoxClick(dataset.code) : undefined}
      renderSystemFlag={() => <SystemFlag messageText={dataModelName(dataset.data_model)} />}
      selected={dataset.selected}
      single={single}
      system={isVisibleDataModel(dataset.data_model)}
      visibility={dataset.settings.visibility}
    >
      {children}
    </NameDescriptionCard>
    <Card.Content extra>
      <span>{dataset.createdOn}</span>
      {showStatus && (accessRequestAllowed || cohortAllowed) && (
        <DatasetStatusButtons
          accessRequestAllowed={accessRequestAllowed}
          accessRequestSupported={accessRequestSupported}
          accessRequestUnsupportedReasons={accessRequestUnsupportedReasons}
          className="float-r"
          code={dataset.code}
          cohortAllowed={cohortAllowed}
          cohortSupported={cohortSupported}
          cohortUnsupportedReasons={cohortUnsupportedReasons}
          dictionaryCode={dataset.primary_dictionary}
          hasConditions={hasConditions}
          icon
          name={dataset.catalogue.title}
          newCohort={newCohort}
          newCohortCode={newCohortCode}
          newRequestCode={newRequestCode}
          showConditions={showConditions}
        />
      )}
    </Card.Content>
  </CardItem>
);

export default DatasetCardItemWrapper;
